import {
  BASE_NAV_HEIGHT,
  BOTTOM_NAV_HEIGHT_CSS_VAR,
  BOTTOM_NAV_HEIGHT_MOBILE,
  NAV_HEIGHT_CSS_VARS,
  RECENT_ORDERS_TAB_BANNER_HEIGHT_CSS_VAR,
  STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR,
  TOP_BANNER_DESKTOP_HEIGHT_CSS_VAR,
  TOP_BANNER_MOBILE_HEIGHT_CSS_VAR,
  type NavHeightKey,
} from "../constants/layoutHeights";

/** Write base nav heights (plus optional banner offset) to :root CSS variables. */
export function setNavHeightCssVars(
  bannerOffsetPx: number,
  targets: NavHeightKey[] = ["generic", "desktop", "mobile"]
) {
  const root = document.documentElement;
  for (const key of targets) {
    root.style.setProperty(
      NAV_HEIGHT_CSS_VARS[key],
      `${BASE_NAV_HEIGHT[key] + bannerOffsetPx}px`
    );
  }
}

/** Reset nav height CSS vars to base values (no banner offset). */
export function initBaseNavHeightCssVars() {
  setNavHeightCssVars(0);
  document.documentElement.style.setProperty(
    BOTTOM_NAV_HEIGHT_CSS_VAR,
    `${BOTTOM_NAV_HEIGHT_MOBILE}px`
  );
  document.documentElement.style.setProperty(
    TOP_BANNER_MOBILE_HEIGHT_CSS_VAR,
    "0px"
  );
  document.documentElement.style.setProperty(
    TOP_BANNER_DESKTOP_HEIGHT_CSS_VAR,
    "0px"
  );
  document.documentElement.style.setProperty(
    STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR,
    "0px"
  );
  document.documentElement.style.setProperty(
    RECENT_ORDERS_TAB_BANNER_HEIGHT_CSS_VAR,
    "0px"
  );
}

export function setTopBannerMobileHeightCssVar(bannerPx: number) {
  document.documentElement.style.setProperty(
    TOP_BANNER_MOBILE_HEIGHT_CSS_VAR,
    `${bannerPx}px`
  );
}

export function setTopBannerDesktopHeightCssVar(bannerPx: number) {
  document.documentElement.style.setProperty(
    TOP_BANNER_DESKTOP_HEIGHT_CSS_VAR,
    bannerPx > 0 ? `${bannerPx}px` : "0px"
  );
}

/** Mobile top banner: track banner height and expand mobile/generic nav offsets. */
export function setTopBannerMobileLayout(bannerPx: number) {
  setTopBannerMobileHeightCssVar(bannerPx);
  setNavHeightCssVars(bannerPx, ["mobile", "generic"]);
}
